import { ReactNode } from 'react';
import { createStyles, makeStyles } from '@material-ui/styles';
import { ExtendedTheme, InlineText } from 'neon-design-system';

interface Props {
  children: ReactNode;
  styleName?: 'largeBody1' | 'largeBody2' | 'body' | 'footnote' | 'caption1' | 'caption2';
}

const useStyles = makeStyles((theme: ExtendedTheme) =>
  createStyles({
    linkText: {
      color: 'inherit'
    }
  })
);

export const LinkText = ({ children, styleName = 'body' }: Props) => {
  const classes = useStyles();
  return (
    <InlineText styleName={styleName} className={classes.linkText}>
      {children}
    </InlineText>
  );
};
